import { AiModal } from '@aigc/components';
import { useOverlayRef } from '@aigc/overlay-hook';
import { yupResolver } from '@hookform/resolvers/yup';
import { useMutation } from '@tanstack/react-query';
import { Editor } from '@tinymce/tinymce-react';
import { App, Form, Input } from 'antd';
import { useForm } from 'react-hook-form';
import { object, string } from 'yup';
import { FormControl } from '../../../components/form-control';
import { createAnnouncementMutation } from '../api';

export function AnnouncementCreateModal() {
  const overlay_ref = useOverlayRef();
  const { message } = App.useApp();

  const form = useForm({
    mode: 'onChange',
    defaultValues: {
      title: '',
      content: '',
    },
    resolver: yupResolver(
      object({
        title: string()
          .required('请输入公告标题')
          .max(64, '标题不能超过64个字符'),
        content: string().required('请输入公告内容'),
      }),
    ),
  });

  const create = useMutation(createAnnouncementMutation);

  return (
    <AiModal
      title="新增公告"
      width={800}
      confirmLoading={create.isPending}
      onCancel={() => overlay_ref.close()}
      onOk={form.handleSubmit(async (values) => {
        if (create.isPending) return;

        await create.mutateAsync({
          title: values.title,
          content: values.content,
        });
        message.success('创建成功');
        overlay_ref.close();
      })}
    >
      <Form layout="vertical">
        <FormControl
          name="title"
          label="公告标题"
          control={form.control}
          required
          render={({ field }) => (
            <Input {...field} placeholder="请输入公告标题" maxLength={64} />
          )}
        />
        <FormControl
          name="content"
          label="公告内容"
          control={form.control}
          required
          render={({ field }) => (
            <Editor
              ref={field.ref}
              tinymceScriptSrc="/tinymce6/tinymce.min.js"
              init={{ language: 'zh-Hans' }}
              value={field.value}
              onEditorChange={(content) => field.onChange(content)}
              onBlur={field.onBlur}
            ></Editor>
          )}
        />
      </Form>
    </AiModal>
  );
}
